<dx-popup
  title="Génération de statistiques"
  [(visible)]="displayed"
  resizeEnabled="true"
  width="1200"
  height="auto">
  <div class="grid-container full-size">
    <dx-data-grid
      [dataSource]="errors"
      [hoverStateEnabled]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [showRowLines]="true"
      [showBorders]="true"
      columnResizingMode="widget"
    >
      <dxi-column
        caption="Point de télédéclaration"
        dataField="pointTeledeclarationLibelle">
      </dxi-column>
      <dxi-column
        caption="Siret"
        dataField="siret"
        width="14%">
      </dxi-column>
      <dxi-column
        caption="Année"
        dataField="annee"
        width="6%">
      </dxi-column>
      <dxi-column
        caption="Erreur"
        dataField="error">
      </dxi-column>
    </dx-data-grid>
  </div>
</dx-popup>
